"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Colony_vue_1 = __importDefault(require("@/client/components/colonies/Colony.vue"));
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'SelectColony',
    props: {
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selectedColony: undefined,
        };
    },
    components: {
        'colony': Colony_vue_1.default,
        AppButton: AppButton_vue_1.default,
    },
    methods: {
        canSave() {
            return this.selectedColony !== undefined;
        },
        saveData() {
            if (this.selectedColony !== undefined) {
                this.onsave({ type: 'colony', colonyName: this.selectedColony });
            }
        },
    },
});
